__turbopack_context__.v({
  "className": "bebas_neue_88cbac2d-module__UGClcG__className",
});
